import React from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import { IProductData } from 'interfaces/IProductData';
import { getCdnImage } from 'functions';
import ShowDetails from './ShowDetails/index';

export interface IProps {
  cart: IProductData;
  shouldRenderModal: boolean;
}

export default class HeaderTitle extends React.PureComponent <IProps, {}> {
  render() {

    const { cart } = this.props;
    const {props} = this;
    const image = getCdnImage(cart.config.logo);

    const product = props.cart.content;

    const { shouldRenderModal } = props;

    return (
      <Grid
        container={shouldRenderModal}
        className={shouldRenderModal ? 'no-open-modal' : 'open-modal-description'}
      >
        <Grid item xs={ window.innerWidth < 500 ? 3 : 2 }>
          {image && <img className='chk-img' src={image} id="logo-content" />}
        </Grid>
        <Grid
          item
          zeroMinWidth
          xs={9}
        >
          <h1 className='product-name theme-label'>{product.title}</h1>
          {shouldRenderModal && <ShowDetails />}
        </Grid>
      </Grid>
    );
  }
}